<template>
  <section class="referrals__faq">
    <VText variant="h3" gutterBottom>Frequently Asked Questions</VText>

    <AccordionItem title="Can I refer if I'm on the free plan?">
      <VText
        >Yes, you can refer other users to Campsite if you're on the free plan.
        You'll earn credit towards upgrading your own plan to Campsite
        Pro.</VText
      >
    </AccordionItem>
    <AccordionItem title="How much credit can I earn?">
      <VText
        >Your referral link lets you earn up to $70 in credit towards your own
        Pro plan. Whether you earn the full $70 depends on if your users you've
        referred complete the 10-day trial and start their subscription.</VText
      >
    </AccordionItem>
    <AccordionItem title="What counts as a referral?">
      <VText
        >A referral is a new Campsite user who signs up for a paid plan during
        account creation or an existing user who upgrades within 7 days of
        signing up. Existing users have to enter your referral code. Existing
        Campsite users older than seven days cannot use your referral code to
        receive a discount.</VText
      >
    </AccordionItem>
    <AccordionItem title="When do the credits get applied to my account?">
      <VText
        >The credit isn't immediately applied to your account. Your referral
        will have to complete their trial (10 days) and become a subscriber
        before you'll receive the credit. If they cancel before they become a
        subscriber, you won't receive any credit.</VText
      >
    </AccordionItem>
    <AccordionItem title="Can existing Campsite users use my referral code?">
      <VText
        >Yes, an existing user can use your referral code, but they have to
        upgrade within seven days of signing up.</VText
      >
    </AccordionItem>
  </section>
</template>

<script>
import { VText, AccordionItem } from '@campsite-bio/component-lib';

export default {
  components: {
    AccordionItem,
    VText,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
